import { z } from "zod";
import { TipTapDocSchema } from "../tiptapDoc.js";
import { RSSFeedItem } from "./rss-feeds.js";

export const SitewideSummary = z.object({
    id: z.number(),
    createdAt: z.string(),
    updatedAt: z.string(),
    deletedAt: z.string().nullable(),
    type: z.enum(["NEWS", "SOCIAL"]),
    title: z.string(),
    content: z.string(),
    contentJson: TipTapDocSchema.nullable().optional(),
    summary: z.string().nullable(),
    featuredImageURL: z.string().default(""),
});

export const schema = {
    getSitewideSummaries: {
        input: z.object({
            limit: z.number().min(1).max(100).optional(),
            skip: z.number().min(0).optional(),
            take: z.number().min(1).max(100).optional(),
            month: z.number().min(1).max(12).optional(),
            year: z.number().min(1970).optional(),
        }),
        output: z.object({
            summaries: z.array(SitewideSummary),
            totalCount: z.number(),
        }),
    },
    shareSummary: {
        input: z.object({
            email: z.email(),
            recipientName: z.string(),
            summaryId: z.number(),
        }),
        output: z.string(),
    },
    getSummaryById: {
        input: z.object({
            id: z.number(),
        }),
        output: SitewideSummary.nullable(),
    },
    getDigestArticles: {
        input: z.object({
            summaryId: z.number(),
        }),
        output: z.object({
            articles: z.array(RSSFeedItem),
        }),
    },
    getSimilarSummaries: {
        input: z.object({
            summaryId: z.number(),
            limit: z.number().min(1).max(20).default(5),
        }),
        output: z.object({
            summaries: z.array(SitewideSummary),
        }),
    },
};
